module.exports = __webpack_public_path__ + "img/logo-white.ccabbb97.svg";